import type { QueuedChangeFailureEvents } from 'shared/channels/entity';
import { defineChannelContract } from 'shared/channels';
import type {
  CreateChecklistSectionRequest,
  DeleteChecklistSectionRequest,
  DeleteChecklistSectionDocumentRequest,
  EditChecklistSectionRequest,
  ReorderChecklistSectionRequest,
} from 'shared/domain/messages/checklistSection/eventMessages';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { ChecklistSectionInDto } from 'shared/dtos/in/template';

/**
 * Checklist section events, each with the change's `uniqueId`. A create
 * answers with the created section; the other outcomes carry the server's
 * answer and stay `unknown`.
 */
export type ChecklistSectionEvents = QueuedChangeFailureEvents & {
  [DomainMessagesTypes.checklistSectionCreated]: ChecklistSectionInDto;
  [DomainMessagesTypes.checklistSectionUpdated]: unknown;
  [DomainMessagesTypes.checklistSectionDeleted]: unknown;
  [DomainMessagesTypes.checklistSectionReordered]: unknown;
  [DomainMessagesTypes.checklistSectionDocumentDeleted]: unknown;
};

/** Checklist section changes; each resolves once queued, its outcome follows as an event. */
export type ChecklistSectionRequests = {
  create: { request: CreateChecklistSectionRequest; response: void };
  edit: { request: EditChecklistSectionRequest; response: void };
  remove: { request: DeleteChecklistSectionRequest; response: void };
  reorder: { request: ReorderChecklistSectionRequest; response: void };
  removeDocument: { request: DeleteChecklistSectionDocumentRequest; response: void };
};

export const checklistSectionContract = defineChannelContract<{
  requests: ChecklistSectionRequests;
  events: ChecklistSectionEvents;
}>('checklistSectionChannel');
